import {Distance} from '../../../Domain/Distance';
import {round} from './Internal/round';

export function formatPeakForcePosition(peakForcePosition: Distance | null): {formatted: string; unit?: string} {
    if (peakForcePosition === null) {
        return {formatted: '-'};
    }
    return {formatted: round(peakForcePosition.centimeters, 0), unit: 'cm'};
}

export function formatAveragePeakForcePosition(peakForcePosition: Distance | null): {formatted: string; unit?: string} {
    if (peakForcePosition === null) {
        return {formatted: '-'};
    }
    return {formatted: round(peakForcePosition.centimeters, 1), unit: 'cm'};
}
